export const BreadcrumbConstant = {
SERVICE_SUMMARY_URL: '/service-summary',
E_DATA_ENTRY_URL: '/e-data-entry',
MY_DOCS_ROUTING_URL: '/my-documents',
ellipsis: [{ text: '...', link: null}]
}